import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageCompteDTO } from '../model/page-compte-dto';
import { Compte } from '../model/compte';

@Injectable({
    providedIn: 'root'
  })
  export class CompteService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    findAllPaging(filter,page,size,sortColomun,descending) 
    {
        return this._restClientService.load<PageCompteDTO>('compte/find-all-paging'
        +'?filter='+filter
        +'&page='+page
        +'&size='+size
        +'&sortColomun='+sortColomun
        +'&descending='+descending);
    }
    
    findAllPagingGestionnaire(filter,codeAgent,page,size,sortColomun,descending) 
    {
        return this._restClientService.load<PageCompteDTO>('compte/find-all-by-gestionnaire-paging'
        +'?filter='+filter
        +'&codeAgent='+codeAgent
        +'&page='+page
        +'&size='+size
        +'&sortColomun='+sortColomun
        +'&descending='+descending);
    }


    findByRequest(requestid) {
        return this._restClientService.load<Compte>('compte/find-by-request?requestid='+requestid);
    }

    

}      

    